import { Typography, styled } from '@mui/material';

const StyledNewsDate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(14)
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.pxToRem(16)
  }
}));

export default StyledNewsDate;
